import type { ProvidersListFilters } from '@openx/components-provider/lib/components/types';
import type { AllTableCriteria } from '@openx/types/tableCriteria';

export const adjustCriteriaFilters = (criteria: AllTableCriteria<ProvidersListFilters>) => {
  const byPhrase = {
    fields: ['id', 'name'],
    phrase: criteria.filters?.phrase ?? '',
  };

  return { byPhrase };
};
